import * as actionType from "../store/action";

export const setFilters = (filters) => ({
  type: actionType.SET_FILTERS,
  payload: filters,
});

export const clearFilters = () => ({
  type: actionType.CLEAR_FILTERS,
});

export const setStatusFilter = (status) => ({
  type: actionType.SET_STATUS_FILTER,
  payload: status,
});

export const setBaseProducts = (products) => ({
  type: actionType.SET_BASE_PRODUCTS,
  payload: products,
});

export const setCategoryChips = (chips) => ({
  type: actionType.SET_CATEGORY_CHIPS,
  payload: chips,
});

export const addCategoryChip = (chip) => ({
  type: actionType.ADD_CATEGORY_CHIP,
  payload: chip,
});

export const removeCategoryChip = (id) => ({
  type: actionType.REMOVE_CATEGORY_CHIP,
  payload: id,
});

export const updateCategoryChip = (oldId, newChip) => ({
  type: actionType.UPDATE_CATEGORY_CHIP,
  payload: { oldId, newChip },
});

export const setExtraColumns = (columns) => ({
  type: actionType.SET_EXTRA_COLUMNS,
  payload: columns,
});

export const reload = () => ({
  type: actionType.RELOAD,
});
